import { ref, computed } from 'vue'
import { useVaspWalletDetailsQuery } from '../api/queries/useVaspWalletDetailsQuery'
import type { VaspWalletListItem } from '../types/cryptoWalletTypes'

export function useVaspWalletDrawer() {
  const drawerVisible = ref(false)
  const selectedWalletId = ref('')
  const selectedWallet = ref<VaspWalletListItem | null>(null)

  const {
    data: details,
    isLoading: detailsLoading,
    refetch: refetchDetails,
  } = useVaspWalletDetailsQuery(computed(() => selectedWalletId.value))

  function openDrawer(wallet: VaspWalletListItem) {
    selectedWallet.value = wallet
    selectedWalletId.value = wallet.id
    drawerVisible.value = true
  }

  function closeDrawer() {
    drawerVisible.value = false
    selectedWallet.value = null
    // `selectedWalletId` is deliberately kept: clearing it disables the detail
    // query, which drops the cached row and makes reopening the same wallet
    // flash a skeleton. The drawer is hidden, so nothing stale is on screen.
  }

  return {
    drawerVisible,
    selectedWallet,
    details,
    detailsLoading,
    // Exposed so the drawer can re-read the row on demand after a failed sync —
    // an attempt refused against a state the operator could not see is fixed by
    // refreshing, not by retrying the same action.
    refetchDetails,
    openDrawer,
    closeDrawer,
  }
}
